var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0784 3.03922L12.3348 0.281641C12.1535 0.10126 11.9082 0 11.6524 0C11.3967 0 11.1513 0.10126 10.97 0.281641L1.24375 9.99391L0.355719 13.8265C0.325085 13.9666 0.326135 14.1118 0.358793 14.2514C0.39145 14.391 0.454891 14.5216 0.544479 14.6336C0.634067 14.7456 0.74754 14.8361 0.876609 14.8987C1.00568 14.9612 1.14708 14.9941 1.29049 14.9949C1.35731 15.0017 1.42464 15.0017 1.49147 14.9949L5.36609 14.1069L15.0784 4.40398C15.2587 4.22269 15.36 3.97734 15.36 3.7216C15.36 3.46585 15.2587 3.22051 15.0784 3.03922ZM4.89871 13.2656L1.26712 14.0275L2.09439 10.466L9.37159 3.21682L12.1759 6.02114L4.89871 13.2656ZM12.8022 5.34343L9.99788 2.53911L11.6244 0.921959L14.382 3.72627L12.8022 5.34343Z",
    fill: "#929292"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.4873dd31a229bf4f4c2ee13347192bec.svg";
export { ForwardRef as ReactComponent };